<div mat-dialog-title>
  <mat-toolbar>
    <mat-toolbar-row>
      <div style="flex: auto; text-overflow: ellipsis">Clients Trips History for {{ data.consumerName }}</div>

      <button
        mat-icon-button
        type="button"
        [mat-dialog-close]="false"
        matTooltip="Close"
        color="primary"
        style="margin: -1em 0">
        <mat-icon aria-label="Close">close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
</div>

<div mat-dialog-content style="padding-top: 3px">
  <dx-data-grid
    #grid
    height="400"
    [dataSource]="dso"
    [columnChooser]="{ enabled: false }"
    [searchPanel]="{ visible: false }"
    [hoverStateEnabled]="true"
    [editing]="{ allowAdding: false, allowUpdating: false, allowDeleting: false }"
    [pager]="{ visible: false }"
    [paging]="{ enabled: true, pageSize: 50 }"
    [scrolling]="{ mode: 'infinite' }"
    (onSelectionChanged)="grid_onSelectionChanged($event)">
    <dxo-search-panel [visible]="false"></dxo-search-panel>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-filter-panel [visible]="false"></dxo-filter-panel>
    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

    <dxi-column caption="Date" dataField="vdate" dataType="datetime" format="shortDate"></dxi-column>
    <dxi-column caption="Vehicle #" dataField="meta.vehicle.internalId" dataType="number"></dxi-column>
    <dxi-column caption="Driver" [calculateCellValue]="getDriverName"></dxi-column>
    <dxi-column caption="Actual Pickup" dataField="pickupTime" cellTemplate="pick_cell"></dxi-column>
    <dxi-column caption="Actual Dropoff" dataField="dropoffTime" cellTemplate="drop_cell"></dxi-column>
    <dxi-column caption="Trip ID" dataField="vTripId" dataType="string"></dxi-column>
    <dxi-column caption="Delivery Name" dataField="deliveryName" dataType="string"></dxi-column>
    <dxi-column caption="Service Type" dataField="vServiceType" dataType="string"></dxi-column>
    <dxi-column caption="Marker" dataField="marker" dataType="string"></dxi-column>
    <dxi-column caption="Status" dataField="status" [calculateCellValue]="getStatusText"></dxi-column>

    <ng-container *dxTemplate="let cellInfo of 'pick_cell'">
      <a
        *ngIf="cellInfo.value"
        target="_blank"
        class="show-loop-link"
        [href]="getMapURL(cellInfo.data.meta.pickUpDeviceLocation)"
        title="Pickup location, click to view on map"
        >{{ formatTimeString(cellInfo.value) }}</a
      >
    </ng-container>

    <ng-container *dxTemplate="let cellInfo of 'drop_cell'">
      <a
        *ngIf="cellInfo.value"
        target="_blank"
        class="show-loop-link"
        [href]="getMapURL(cellInfo.data.meta.dropOffDeviceLocation)"
        title="Dropoff location, click to view on map"
        >{{ formatTimeString(cellInfo.value) }}</a
      >
    </ng-container>
  </dx-data-grid>
</div>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
</div>
